import { Filter } from '@anytag/shared-molecules';
import { useMarketplaceInfluencersFilter } from './hooks';
import { BasicFilter, BasicFilterProps } from './BasicFilter';

export type MarketplaceInfluencersFilterProps = Omit<BasicFilterProps, 'onSubmit'>;

export const MarketplaceInfluencersFilter = (props: MarketplaceInfluencersFilterProps) => {
  const { filter, setFilterForm } = useMarketplaceInfluencersFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="rounded-none">
      <BasicFilter {...props} />
    </Filter.Provider>
  );
};

export { useMarketplaceInfluencersFilter };
export * from './schemaTypes';
export * from './hooks';
